import React, {useState} from "react";
import {useFormState, createContainer} from "@obby/components";
import {ContactFormSchema} from "@obby/components/src/forms/ContactForm/ContactForm.schema";
import {useStore} from "~/hooks/useStore";
import axios from "~/config/axios";

function useContactPageContainer() {

  const [{user}] = useStore("authentication")
  const [state, setState] = useState({
    isSending: false, isSent: false
  })
  const {isSending, isSent} = state;

  const {
    values,
    touched,
    errors,
    setFieldValue,
    setFieldTouched,
    submit
  } = useFormState({
    schema: ContactFormSchema(),
    values: {
      email: user?.emails?.[0].address || ""
    }
  });

  function onBlur(name){
    setFieldTouched(name)
  }

  function onChange(value, name){
    setFieldValue(name, value);
  }

  async function onSubmit() {
    const isValid = await submit();
    if (!isValid) return;

    setState({...state, isSending: true});
    await axios.post("sendEmailObby", {
      content: values
    });
    setState({...state, isSending: false, isSent: true});

  }

  return {
    isSent,
    isSending,
    values,
    touched,
    errors,
    helpers: {},
    actions: {
      onBlur,
      onChange,
      onSubmit
    }
  };
}

export const ContactPageContainer = createContainer(useContactPageContainer);
